import Vue from 'vue';
import VueDot from '@cnamts/vue-dot/src/index';

// Import VueDot styles
import '@cnamts/vue-dot/dist/vue-dot.css';

// Import dayjs locale
import 'dayjs/locale/fr';

// Import the theme
import { icons } from 'amelipro-ds/src/assets/icons';

// Register v-facade directive
//import InputFacade from 'vue-input-facade';
//Vue.use(InputFacade, VueDot, {
//    theme: {
//        icons
//    }
//});

Vue.use(VueDot, {
    theme: {
        icons
    }
});
